import {Injectable} from '@angular/core';
import {FormDefinitionFormModel} from "../../../api/entity/formDefinitionForm.model";
import {FormDefinitionFormDataService} from "./formDefinitionFormData.service";
import {FormDefinitionFormConverter} from "../../../api/entity/converter/formDefinitionForm.converter";
import {AbstractDataServiceDtoAdapter} from "../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";

@Injectable()
export class FormDefinitionFormDataServiceAdapter extends AbstractDataServiceDtoAdapter<FormDefinitionFormModel, FormDefinitionFormConverter> {
    constructor(dataService: FormDefinitionFormDataService, converter: FormDefinitionFormConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): FormDefinitionFormModel {
        return new FormDefinitionFormModel();
    }

}
